// extracted by mini-css-extract-plugin
export default {"grid":"ThumbnailContainerV2_grid__wY5Xy"};